import { render, staticRenderFns } from "./ErrorPagesForm.vue?vue&type=template&id=56105b7c&scoped=true&"
import script from "./ErrorPagesForm.vue?vue&type=script&lang=js&"
export * from "./ErrorPagesForm.vue?vue&type=script&lang=js&"
import style0 from "./ErrorPagesForm.vue?vue&type=style&index=0&id=56105b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56105b7c",
  null
  
)

export default component.exports